/* Democratic: ajusta cada foto de producto a su recuadro cuadrado.
   - Foto cuadrada: llena el recuadro.
   - Foto de estudio con fondo liso: se muestra completa y el recuadro toma el color del fondo.
   - Foto de ambiente (fondo con detalle): llena el recuadro recortando un poco las orillas. */
(function () {
  function sample(img) {
    var w = 48, h = Math.max(1, Math.round(48 * img.naturalHeight / img.naturalWidth));
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, w, h);
    var d = x.getImageData(0, 0, w, h).data, px = [];
    var wide = img.naturalWidth > img.naturalHeight;
    function at(i, j) { var k = (j * w + i) * 4; px.push([d[k], d[k + 1], d[k + 2]]); }
    if (wide) { for (var i = 0; i < w; i++) { at(i, 0); at(i, 1); at(i, h - 1); at(i, h - 2); } }
    else { for (var j = 0; j < h; j++) { at(0, j); at(1, j); at(w - 1, j); at(w - 2, j); } }
    var m = [0, 0, 0]; px.forEach(function (p) { m[0] += p[0]; m[1] += p[1]; m[2] += p[2]; });
    m = m.map(function (v) { return v / px.length; });
    var dev = 0; px.forEach(function (p) { dev += Math.abs(p[0] - m[0]) + Math.abs(p[1] - m[1]) + Math.abs(p[2] - m[2]); });
    return { color: 'rgb(' + m.map(Math.round).join(',') + ')', flat: dev / px.length < 18 };
  }
  function setFit(img, v) { img.style.setProperty('object-fit', v, 'important'); }
  function fit(img) {
    if (img.dataset.dmFit || !img.naturalWidth) return;
    img.dataset.dmFit = '1';
    var r = img.naturalWidth / img.naturalHeight;
    var primary = !img.previousElementSibling || img.previousElementSibling.tagName !== 'IMG';
    var box = img.closest('.media') || img.parentElement;
    if (Math.abs(r - 1) < 0.04) { setFit(img, 'cover'); return; }
    try {
      var s = sample(img);
      if (s.flat) { setFit(img, 'contain'); img.style.background = s.color; if (primary) box.style.background = s.color; }
      else { setFit(img, 'cover'); }
    } catch (e) { setFit(img, 'contain'); }
  }
  function run(root) {
    (root || document).querySelectorAll('.card-wrapper .card__media img').forEach(function (img) {
      if (img.complete) fit(img); else img.addEventListener('load', function () { fit(img); }, { once: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) run(n); }); }); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
